import { Component, Directive } from '@angular/core';

@Component({
  selector: 'uex-dropdown-text',
  template: '<h6 class="uex-dropdown-text dropdown-text"><ng-content></ng-content></h6>'
})
export class DropdownTextComponent { }

@Directive({
  selector: '[uex-dropdown-text]',
  host: {
    class: 'uex-dropdown-text dropdown-text'
  }
})
export class DropdownTextDirective { }
